export const Page = ({ over, title, sub, children, right, testid }) => (
  <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16" data-testid={testid}>
    <div className="fade-up mb-10 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
      <div>
        {over && <p className="label-over">{over}</p>}
        <h1 className="mt-3 font-serif text-4xl tracking-tight sm:text-5xl">{title}</h1>
        {sub && <p className="mt-3 max-w-2xl text-base text-neutral-400">{sub}</p>}
      </div>
      {right}
    </div>
    {children}
  </div>
);

export const Empty = ({ icon: Icon, text, children, testid }) => (
  <div className="surface flex flex-col items-center justify-center gap-4 px-6 py-16 text-center" data-testid={testid}>
    {Icon && <Icon className="h-8 w-8 text-[#D4AF37]" />}
    <p className="max-w-md text-sm text-neutral-400">{text}</p>
    {children}
  </div>
);
